import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useProjectStore from '../../stores/projectStore';

export default function ProjectSwitcher() {
  const [open, setOpen] = useState(false);
  const projects = useProjectStore((s) => s.projects);
  const currentProjectId = useProjectStore((s) => s.currentProjectId);
  const setCurrentProject = useProjectStore((s) => s.setCurrentProject);
  const navigate = useNavigate();
  const ref = useRef(null);

  const current = projects.find((p) => p.id === currentProjectId);

  useEffect(() => {
    function onClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const handleSelect = (id) => {
    setCurrentProject(id);
    setOpen(false);
  };

  const handleManage = () => {
    setOpen(false);
    navigate('/projects');
  };

  const initials = (current?.name || '?')
    .split(/\s+/)
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <div className="relative px-2.5 pt-2 pb-3 border-b border-white/[.08]" ref={ref}>
      <div className="text-white/45 text-[9.5px] font-semibold tracking-wider px-1 mb-1.5">
        AKTUELLES PROJEKT
      </div>
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg bg-white/[.07] hover:bg-white/[.12] border border-white/[.08] transition-colors text-left"
      >
        <div
          className="w-7 h-7 rounded-md flex items-center justify-center text-[11px] font-bold text-white shrink-0"
          style={{ backgroundColor: current?.color || '#0C9488' }}
        >
          {initials}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-white text-[12.5px] font-semibold truncate leading-tight">
            {current?.name || 'Kein Projekt'}
          </div>
          {current?.domain && (
            <div className="text-white/45 text-[10px] truncate leading-tight mt-px">
              {current.domain}
            </div>
          )}
        </div>
        <span className="text-white/60 text-[10px]">{open ? '▴' : '▾'}</span>
      </button>

      {open && (
        <div className="absolute left-2.5 right-2.5 top-full mt-1 bg-white rounded-lg shadow-xl border border-black/10 overflow-hidden z-50 max-h-[420px] overflow-y-auto">
          <div className="px-3 py-2 border-b border-gray-100 text-[10px] text-gray-400 uppercase tracking-wider font-semibold">
            Projekte ({projects.length})
          </div>
          {projects.map((p) => (
            <button
              key={p.id}
              onClick={() => handleSelect(p.id)}
              className={`w-full flex items-center gap-2.5 px-3 py-2 hover:bg-gray-50 transition-colors text-left ${
                p.id === currentProjectId ? 'bg-teal/[.06]' : ''
              }`}
            >
              <div
                className="w-6 h-6 rounded-md flex items-center justify-center text-[10px] font-bold text-white shrink-0"
                style={{ backgroundColor: p.color || '#0C9488' }}
              >
                {(p.name || '?')
                  .split(/\s+/)
                  .map((s) => s[0])
                  .slice(0, 2)
                  .join('')
                  .toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-[12.5px] font-medium text-gray-900 truncate">{p.name}</div>
                {p.domain && (
                  <div className="text-[10.5px] text-gray-400 truncate">{p.domain}</div>
                )}
              </div>
              {p.id === currentProjectId && <span className="text-teal text-[12px]">✓</span>}
              {p.is_default && p.id !== currentProjectId && (
                <span className="text-[9px] text-gray-400">DEFAULT</span>
              )}
            </button>
          ))}
          <button
            onClick={handleManage}
            className="w-full px-3 py-2.5 text-left text-[12px] text-teal font-medium hover:bg-teal/[.06] border-t border-gray-100"
          >
            + Projekte verwalten
          </button>
        </div>
      )}
    </div>
  );
}
